import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({

    ConferenceButton: {
		marginInlineStart: "10px",
		color: "blue",
		height: "36px",
        width: "120px",
        borderRadius: "4px",
        cursor: "pointer",
		"&:hover": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},

}));